import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1832a8b2&scoped=true&"
import script from "./tccSection.ts?vue&type=script&lang=ts&"
export * from "./tccSection.ts?vue&type=script&lang=ts&"
import style0 from "./tccSection.css?vue&type=style&index=0&id=1832a8b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1832a8b2",
  null
  
)

export default component.exports